import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { message } from 'antd';
import { findKey } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  RCAcceptCall,
  RCBack,
  RCDeclineCall,
  RCHome,
  RCMicrophone,
  RCNavigation,
  RCPower,
  RCTV,
  RCVolumeDown,
  RCVolumeUp,
} from '../Common/Icons';
import { RCButtons, rcEventTypes, RCKeyButtonMap } from './helpers';

const buttonComponents = [
  { component: RCTV, button: RCButtons.RCTV },
  { component: RCMicrophone, button: RCButtons.RCMicrophone },
  { component: RCPower, button: RCButtons.RCPower },
  { component: RCBack, button: RCButtons.RCBack },
  { component: RCHome, button: RCButtons.RCHome },
  { component: RCVolumeUp, button: RCButtons.RCVolumeUp },
  { component: RCAcceptCall, button: RCButtons.RCAcceptCall },
  { component: RCVolumeDown, button: RCButtons.RCVolumeDown },
  { component: RCDeclineCall, button: RCButtons.RCDeclineCall },
];

const RemoteControlLayout = ({ rcKey, action, hubRecord, providerid }) => {
  const [buttonPressedFromPortal, setButtonPressedFromPortal] = useState('');
  const deviceManagementApi = useSelector((state) => state.apis.deviceManagementApi);
  const trans = useSelector(translator);
  const buttonPressed = RCKeyButtonMap[rcKey];
  const isSelected = (button) => buttonPressed === button && action === 'press';
  const isNavButtonSelected =
    [
      RCButtons.RCArrowUp,
      RCButtons.RCArrowDown,
      RCButtons.RCArrowLeft,
      RCButtons.RCArrowRight,
    ].includes(buttonPressed) && action === 'press';

  const handleMouseDown = (button) => {
    setButtonPressedFromPortal(button);

    const errorCallback = (error) => {
      message.error('Error sending RCU command');
      console.error('Error sending RCU command:', error);
    };

    const successCallback = (data) => {
      // Handle success response if needed
    };

    let keycode = findKey(RCKeyButtonMap, (v) => v === button);

    // The keycode of the HOME key needs to be KEYCODE_HOME
    // instead of KEYCODE_F4
    // to match the expected value in the backend.
    if (keycode === 'KEYCODE_F4') {
      keycode = 'KEYCODE_HOME';
    }

    try {
      deviceManagementApi.rcuCommand(
        rcEventTypes.KEY_INPUT_EVENT,
        providerid,
        hubRecord.deviceuuid,
        { source: 'System', params: [{ name: 'keycode', value: keycode }] },
        apiCallback({
          translator: trans,
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  const handleMouseUp = () => setButtonPressedFromPortal('');

  return (
    <div className="remote-body">
      <div className="remote-content">
        <div className="row-1">
          {buttonComponents.slice(0, 3).map(({ component: Component, button }) => (
            <Component
              className="rc-button"
              key={button}
              isSelected={isSelected(button)}
              isButtonPressedFromPortal={buttonPressedFromPortal === button}
              onMouseDown={() => handleMouseDown(button)}
              onMouseUp={handleMouseUp}
            />
          ))}
        </div>
        <div className="row-2">
          <RCNavigation
            isSelected={isNavButtonSelected}
            button={buttonPressed}
            buttonPressedFromPortal={buttonPressedFromPortal}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
          />
          <button
            className={`rc-button ${isSelected(RCButtons.RCOK) || buttonPressedFromPortal === RCButtons.RCOK ? 'ok-button-selected' : 'ok-button'}`}
            onMouseDown={() => handleMouseDown(RCButtons.RCOK)}
            onMouseUp={handleMouseUp}
          >
            OK
          </button>
        </div>
        <div className="row-3">
          {buttonComponents.slice(3, 5).map(({ component: Component, button }) => (
            <Component
              className="rc-button"
              key={button}
              isSelected={isSelected(button)}
              isButtonPressedFromPortal={buttonPressedFromPortal === button}
              onMouseDown={() => handleMouseDown(button)}
              onMouseUp={handleMouseUp}
            />
          ))}
        </div>
        <div className="row-4">
          {buttonComponents.slice(5, 7).map(({ component: Component, button }) => (
            <Component
              className="rc-button"
              key={button}
              isSelected={isSelected(button)}
              isButtonPressedFromPortal={buttonPressedFromPortal === button}
              onMouseDown={() => handleMouseDown(button)}
              onMouseUp={handleMouseUp}
            />
          ))}
        </div>
        <div className="row-5">
          {buttonComponents.slice(7).map(({ component: Component, button }) => (
            <Component
              className="rc-button"
              key={button}
              isSelected={isSelected(button)}
              isButtonPressedFromPortal={buttonPressedFromPortal === button}
              onMouseDown={() => handleMouseDown(button)}
              onMouseUp={handleMouseUp}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
RemoteControlLayout.propTypes = {
  rcKey: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  hubRecord: PropTypes.object,
  providerid: PropTypes.string,
};

export default RemoteControlLayout;
